// src/redux/users/usersSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetVlpUsersByGroup } from '../vlp/services/UsersService'; // <-- adjust path as needed

// Async thunk to load users
export const fetchUsers = createAsyncThunk(
  'users/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetVlpUsersByGroup();
      // support two possible shapes: { statusCode, results } or direct array
      const users = response && response.results ? response.results : response;
      return users || [];
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch users');
    }
  }
);

const initialState = {
  data: [],          // array of UsersDto objects (camelCase)
  status: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    // Optional local setters for manual updates
    setUsers: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearUsers: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setUsers, clearUsers } = usersSlice.actions;

// Selectors
export const selectUsersData = (state) => state.users.data;
export const selectUsersStatus = (state) => state.users.status;
export const selectUsersError = (state) => state.users.error;

export default usersSlice.reducer;